import React from 'react';
import PropTypes from 'prop-types';
import { TRIM } from 'site-modules/shared/constants/allowed-inventory-request-params';
import { UsurpTrimFilterCheckbox } from 'site-modules/shared/components/inventory/usurp-filter/usurp-filter-checkbox/usurp-trim-filter-checkbox';
import { UsurpFilterCheckbox } from 'site-modules/shared/components/inventory/usurp-filter/usurp-filter-checkbox/usurp-filter-checkbox';
import { facetShape } from 'site-modules/shared/constants/inventory/filters-constants';

export function UsurpFilterCheckboxFactory({ facet = {}, ...restProps }) {
  if (facet.type === TRIM) {
    return <UsurpTrimFilterCheckbox {...restProps} facet={facet} />;
  }

  return <UsurpFilterCheckbox {...restProps} facet={facet} />;
}

UsurpFilterCheckboxFactory.propTypes = {
  facet: facetShape,
  onUpdate: PropTypes.func.isRequired,
};
